export enum DermloopAssessmentTypeEnum {
  Pathology = 'pathology',
  Teledermatology = 'teledermatology',
  ConditionTriage = 'lesionTriage',
  TeleResponseReview = 'teleResponseReview',
  ConditionDetails = 'skinConditionDetails',
  NewConditionDiagnosis = 'newConditionDiagnosis',
  PatientInfoEdited = 'patientInfoEdited',
  /** One completed, form-driven specialist answer to a referral. */
  SpecialistResponse = 'specialistResponse',
}
